module.exports = __webpack_public_path__ + "static/media/42-iveco.b1ea8759.jpg";